import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import CustomTransfer from 'App/Screens/SubModules/UserGroup/User/Management/Component/CustomTransfer'
import WarningLabel from '../WarningLabel'
import ErrorLabel from '../ErrorLabel'

class PageModules extends React.PureComponent {
  constructor(props) {
    super(props)

    this.moduleTitles = ['Available Allowed Modules', 'Chosen Allowed Modules']
    this.state = {
      errorMessage: '',
    }
  }

  onFieldTouched = (isFieldsTouched) => {
    this.props.onFieldTouched(isFieldsTouched, () => {
      this.setState({ errorMessage: '' })
    })
  }

  validateFields = () => {
    if (get(this._module, 'validateFields')) {
      return this._module.validateFields()
    }
    return undefined
  }

  setError = (errorMessage) => {
    this.props.setActiveKey(this.props.tabKey, () => {
      this.setState({ errorMessage })
    })
  }

  render() {
    const { readOnly, groupHelper, group, onChange } = this.props
    const { errorMessage } = this.state

    return (
      <div>
        { errorMessage && <ErrorLabel errorMessage={errorMessage} /> }
        <WarningLabel tabName='Modules' groupName={get(group, 'name', '')} />
        <div style={{ padding: '12px 24px' }}>
          <CustomTransfer
            ref={ref => {this._module = ref}}
            readOnly={readOnly}
            titles={this.moduleTitles}
            dataSource={groupHelper.module}
            initialValue={get(group, 'allowed_modules', [])}
            setTouched={this.onFieldTouched}
            onChange={onChange}
          />
        </div>
      </div>
    )
  }
}

PageModules.propTypes = {
  readOnly: PropTypes.bool,
  tabKey: PropTypes.string,
  groupHelper: PropTypes.object,
  group: PropTypes.object,
  onFieldTouched: PropTypes.func,
  onChange: PropTypes.func,
}

PageModules.defaultProps = {
  readOnly: false,
  tabKey: null,
  groupHelper: { module: [] },
  group: null,
  onFieldTouched: () => null,
  onChange: () => null,
  setActiveKey: (tabKey, callback = () => null) => callback(),
}

export default PageModules